// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select .flag[data-v-479527d2]{margin:0!important}#select-country .v-select[data-v-479527d2]{width:80px}.span-flag-name[data-v-479527d2]{margin-left:10px;margin-top:6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
